import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IApiResponse } from '@core/interfaces/api-response.interface';
import { Observable } from 'rxjs';
import {
  TGlobalTemplateApi,
  TGlobalTemplateCreatePayload,
  TGlobalTemplateUpdatePayload,
} from './template-settings.interface';

@Injectable({
  providedIn: 'root',
})
export class TemplateSettingsService {
  constructor(private readonly http: HttpClient) {}

  public createGlobalTemplate(template: TGlobalTemplateCreatePayload): Observable<TGlobalTemplateApi> {
    return this.http.post<TGlobalTemplateApi>('global-templates', template);
  }

  public deleteGlobalTemplate(id: string): Observable<TGlobalTemplateApi> {
    return this.http.delete<TGlobalTemplateApi>(`global-templates/${id}`);
  }

  public getGlobalTemplates(params?: HttpParams): Observable<IApiResponse<TGlobalTemplateApi[]>> {
    return this.http.get<IApiResponse<TGlobalTemplateApi[]>>('global-templates', { params });
  }

  public updateGlobalTemplate(id: string, template: TGlobalTemplateUpdatePayload): Observable<TGlobalTemplateApi> {
    return this.http.put<TGlobalTemplateApi>(`global-templates/${id}`, template);
  }
}
